import MobileDrawerButton from '@/components/MobileDrawerButton'
import SvgLib from '@/components/SvgLib'

export default {
  name: 'Rewards',
  template: '#rewards-template',
  components: { MobileDrawerButton, SvgLib },
  data () {
    return {
      bracketNum: 8,
      rewardsAssetPath: window.clash2018.versionedAssetPath + '/static/img/rewards/',
      modalActive: false,
      modalInfo: 1,
      cupModifier: '',
      bannerTier: 'normal'
    }
  },
  computed: {
    lootColor () {
      let color = 'blue'
      if (this.bracketNum === 8) {
        color = 'purple'
      } else if (this.bracketNum === 16) {
        color = 'orange'
      }
      return color
    },
    lootType () {
      return this.$store.state.ticketChoice === 1 ? 'capsule' : 'orb'
    },
    lootClasses () {
      return {
        'rewards-info-img-loot--blue': this.lootColor === 'blue',
        'rewards-info-img-loot--purple': this.lootColor === 'purple',
        'rewards-info-img-loot--orb': this.lootType === 'orb',
        'rewards-info-img-loot--capsule': this.lootType === 'capsule'
      }
    },
    bannerImgPath () {
      let cupModifier = this.cupModifier !== '' ? '-' + this.cupModifier : ''
      return this.rewardsAssetPath + 'banners/banners-' + this.bannerTier + cupModifier + '.png'
    },
    trophyImgPath () {
      return this.rewardsAssetPath + 'trophies/trophy-4bracket-tier' + this.$store.state.tier + '.png'
    },
    lootImgPath () {
      return this.rewardsAssetPath + this.lootType + 's/' + this.lootType + '-' + this.lootColor + '.png'
    }
  },
  methods: {
    openModal (info) {
      this.modalInfo = info
      this.modalActive = true
      var trackingName = ''
      if (info === 0) {
        trackingName = 'Victory Points'
      } else if (info === 1) {
        trackingName = 'Bracket Winner'
      } else if (info === 2) {
        if (this.$store.state.ticketChoice === 1) {
          trackingName = 'Capsule Upgraded'
        } else {
          trackingName = 'Orb Upgraded'
        }
      }
      if (this.$route.path.includes('bracket')) {
        this.trackEvent('8-Team Bracket (Rewards)', '8-Team Bracket (Rewards): Button: ' + trackingName)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/triumph/Rewards.js